import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import {
  HydratedRecommendation,
  RecommendationQueryParams
} from "../../recommendation.types";

export const requestGetProductRecommendations = async (
  id: string,
  params: RecommendationQueryParams
): Promise<HydratedRecommendation[]> => {
  return await instance.get(
    `${ApiRoutesRecommendation.RecommendProduct}/${encodeURIComponent(id)}`,
    { params }
  );
};
